/**
 * @fileoverview Serialize a DiagramSpec into the `diagramBlock` HTML element
 * and parse it back. The spec lives JSON-encoded in a single attribute so the
 * canvas `html` field round-trips unchanged. The attribute is single-quoted;
 * the JSON is escaped for `'` and `<`. Mirrors chartHtml.ts.
 */
import { DiagramSpecSchema, type DiagramSpec } from "@cvx/lib/diagrams/spec";

export function encodeDiagramAttr(spec: DiagramSpec): string {
  return JSON.stringify(spec).replace(/'/g, "&#39;").replace(/</g, "&lt;");
}

export function diagramSpecFromAttr(attr: string): DiagramSpec | null {
  try {
    const json = attr.replace(/&#39;/g, "'").replace(/&lt;/g, "<");
    const parsed = DiagramSpecSchema.safeParse(JSON.parse(json));
    return parsed.success ? parsed.data : null;
  } catch {
    return null;
  }
}

/** Block element TipTap parses into a `diagramBlock` node. */
export function specToDiagramHtml(spec: DiagramSpec): string {
  return `<div data-morgan-diagram='${encodeDiagramAttr(spec)}'></div>`;
}
